/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./StakeView.vue?vue&type=template&id=4c8b2784&scoped=true"
import script from "./StakeView.vue?vue&type=script&lang=js"
export * from "./StakeView.vue?vue&type=script&lang=js"
import style0 from "./StakeView.vue?vue&type=style&index=0&id=4c8b2784&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b2784",
  null
  
)

export default component.exports